<div class="bo-auth-select">
  <label class="bo-auth-select__label" [attr.for]="inputId()">{{ label() }}</label>
  <div class="bo-auth-select__field" [class.bo-auth-select__field--invalid]="control().invalid && control().touched">
    <select
      class="bo-auth-select__native"
      [id]="inputId()"
      [formControl]="control()"
      [attr.aria-label]="ariaLabel() || label()"
      [disabled]="disabled()"
    >
      @if (placeholder()) {
        <option value="" disabled>{{ placeholder() }}</option>
      }
      @for (option of options(); track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
    <span class="bo-auth-select__chevron" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </span>
  </div>
  @if (control().invalid && control().touched) {
    <p class="bo-auth-select__error" role="alert">
      @if (control().errors?.['required']) {
        Este campo es obligatorio
      } @else {
        Campo invalido
      }
    </p>
  }
</div>
